import { useAxios } from '../hooks/useAxios';
import React, { useMemo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarIcon, GridIcon, TodayIcon } from './Icons';

type ResponseData = {
  success: number;
  thisWeek: string;
  today: string;
  overdue: string;
  allWork: number;
  delegated: number;
  assigned: number;
  inTheLoop: number;
  conversations: number;
};

export const useTabs = () => {
  const { t } = useTranslation();
  const [{ data, loading }] = useAxios<ResponseData>({
    url: '/activity/myworkCount',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });
  const [tabs, setTabs] = useState<ResponseData | null>(data);

  useEffect(() => {
    const handleCreateAi = (event: CustomEvent) => {
      setTabs(event.detail as ResponseData);
    }
    window.addEventListener('mywork:ai:add', handleCreateAi, false);

    return () => window.removeEventListener('mywork:ai:add', handleCreateAi, false);
  }, [setTabs]);

  const items = useMemo(
    () => {
      const rawItems = [
        {
          id: 2,
          label: t('This week'),
          count: tabs?.thisWeek ? parseInt(tabs.thisWeek) : 0,
          primary: true,
          icon: <CalendarIcon />,
        },
        {
          id: 1,
          label: t('Today'),
          count: tabs?.today ? parseInt(tabs.today) : 0,
          primary: true,
          icon: <TodayIcon />,
        },
        {
          id: 0,
          label: t('All'),
          count: tabs?.allWork || 0,
          primary: true,
          icon: <GridIcon />,
        },
        {
          id: 5,
          label: t('Requests for me'),
          count: tabs?.assigned || 0,
          primary: false,
        },
        {
          id: 3,
          label: t('Overdue'),
          count: tabs?.overdue ? parseInt(tabs.overdue) : 0,
          primary: false,
        },
        {
          id: 4,
          label: t('Work I delegated'),
          count: tabs?.delegated || 0,
          primary: false,
        },
        {
          id: 6,
          label: t('In the loop'),
          count: tabs?.inTheLoop || 0,
          primary: false,
        },
      ];

      return rawItems;
    },
    [tabs]
  );

  return { items, loading };
};
